/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.357 7.194A4.974 4.974 0 0 1 15 4a5 5 0 0 1 4.996 4.802A5.995 5.995 0 0 1 23 14c0 1.468-.599 2.932-1.466 4.027C20.682 19.105 19.424 20 18 20v-2c.577 0 1.318-.395 1.966-1.214C20.599 15.987 21 14.95 21 14a4 4 0 0 0-2.433-3.68l-.674-.288.072-.73.015-.132.006-.044A4.875 4.875 0 0 0 18 9a3 3 0 0 0-3-3 2.988 2.988 0 0 0-2.964 2.684l-.165 1.556-1.343-.804A2.956 2.956 0 0 0 9 9a3 3 0 0 0-3 3v1.535l-.445.297c-1.236.824-1.885 2.08-2.222 3.205-.105.35-.177.678-.226.963H6v2H1v-1.023a3.711 3.711 0 0 1 .007-.204 10.325 10.325 0 0 1 .41-2.31C1.793 15.208 2.535 13.648 4 12.49V12a5 5 0 0 1 5-5c.474 0 .929.07 1.357.194z" />
        <path d="M12 13.468c.923-.546 2.019-.565 2.923-.212C16.054 13.698 17 14.768 17 16.25c0 .866-.35 1.694-.969 2.3l-.036.037L12 21.78l-3.995-3.195-.037-.036a3.217 3.217 0 0 1 0-4.6 3.332 3.332 0 0 1 4.033-.48zm-2.63 1.906a1.217 1.217 0 0 0-.03 1.718L12 19.22l2.66-2.127c.22-.231.34-.533.34-.843 0-.537-.321-.941-.804-1.13-.495-.193-1.043-.11-1.416.255l-.78.767-.78-.766a1.33 1.33 0 0 0-1.85 0z" />
      </g>
    </g>
  </Icon>
);
export { SvgCloudHeart as CloudHeart };
